<button
  class="back-btn btn btn-bordered-black py-1 h-auto"
  title="Back"
  (click)="router.navigate(['/', routes.home])"
>
  <img
    fetchpriority="high"
    width="12"
    height="12"
    src="images/arrow-left-black.svg"
    alt="Back"
  />
  @if (!isMobile) {
    <span class="ms-2">Go Back</span>
  }
</button>
